<script setup lang="ts">
import type { Faq } from '@/types/faq.types'

defineProps<{
  item: Faq
  isExpanded: boolean
}>()

const emit = defineEmits<{
  toggle: [id: number]
}>()
</script>

<template>
  <div class="faq-item">
    <div class="faq-question" @click="emit('toggle', item.idx)">
      <div class="question-text body-md white">{{ item.title }}</div>
      <img
        v-if="isExpanded"
        src="@/assets/svgs/chevron_up.svg"
        alt="접기"
        class="chevron-icon svg-24 svg-white"
      />
      <img
        v-else
        src="@/assets/svgs/chevron_down.svg"
        alt="펼치기"
        class="chevron-icon svg-24 svg-white"
      />
    </div>
    <div v-if="isExpanded" class="faq-answer body-md white">
      {{ item.content }}
    </div>
  </div>
</template>

<style scoped>
.faq-item {
  margin-bottom: 28px;
  border-radius: 8px;
  background-color: transparent;
  overflow: hidden;
}

.faq-question {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.chevron-icon {
  width: 20px;
  height: 20px;
}

.faq-answer {
  padding: 16px;
  margin-top: 12px;
  border-radius: 8px;
  background-color: var(--gray-800);
  white-space: pre-line;
}
</style>
